"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WhereCondition = (function () {
    function WhereCondition(name, extractor, predicate) {
        this.name = name;
        this.extractor = extractor;
        this.predicate = predicate;
    }
    WhereCondition.prototype.evaluate = function (resolverFactory) {
        var extracted = this.extractor(resolverFactory);
        return !!extracted && this.predicate(extracted);
    };
    WhereCondition.prototype.describe = function () {
        return "".concat(this.name, ".where(").concat(this.predicate, ")");
    };
    return WhereCondition;
}());
exports.default = WhereCondition;
